import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ScoreAnalysis = ({ satData, avg_sat, averageeng, averagemath }) => {
  // Calculate percentiles based on score ranges
  const getPercentile = (score, type) => {
    const ranges = satData[type].scoreRanges;
    // 점수가 200 미만인 경우
    if (score < 200) {
      return "1st";
    }
    // 점수가 400 초과인 경우
    if (score > 400) {
      return "99th";
    }
    // 범위 내에서 적절한 백분위 찾기
    for (const [range, percentile] of Object.entries(ranges)) {
      const [min, max] = range.split('-').map(Number);
      if (score >= min && score <= max) {
        return percentile;
      }
    }
    return "N/A";
  };

  // Common options for all charts
  const commonOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        },
        ticks: {
          color: 'white'
        }
      },
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: 'white'
        }
      }
    },
    plugins: {
      legend: {
        display: false
      }
    }
  };

  // Data for Total SAT Score
  const totalScoreData = {
    labels: ['Your Score', 'National Average'],
    datasets: [
      {
        data: [avg_sat, satData.totalAverageScore],
        backgroundColor: ['rgba(99, 102, 241, 0.8)', 'rgba(99, 102, 241, 0.4)'],
        borderColor: ['rgba(99, 102, 241, 1)', 'rgba(99, 102, 241, 0.6)'],
        borderWidth: 1
      }
    ]
  };

  // Data for English Score
  const englishScoreData = {
    labels: ['Your Score', 'National Average'],
    datasets: [
      {
        data: [averageeng, satData.english.averageScore],
        backgroundColor: ['rgba(59, 130, 246, 0.8)', 'rgba(59, 130, 246, 0.4)'],
        borderColor: ['rgba(59, 130, 246, 1)', 'rgba(59, 130, 246, 0.6)'],
        borderWidth: 1
      }
    ]
  };

  // Data for Math Score
  const mathScoreData = {
    labels: ['Your Score', 'National Average'],
    datasets: [
      {
        data: [averagemath, satData.math.averageScore],
        backgroundColor: ['rgba(34, 197, 94, 0.8)', 'rgba(34, 197, 94, 0.4)'],
        borderColor: ['rgba(34, 197, 94, 1)', 'rgba(34, 197, 94, 0.6)'],
        borderWidth: 1
      }
    ]
  };

  return (
    <div className="w-full space-y-6">
      {/* Percentile Badges */}
      <div className="flex justify-center gap-4">
        <div className="flex flex-col items-center">
          <div className="w-[100px] h-[100px] rounded-full bg-blue-600 flex items-center justify-center">
            <div className="text-center text-white">
              <div className="text-sm">English</div>
              <div className="text-lg font-bold">
                Top {getPercentile(averageeng, 'english')} percentile
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center">
          <div className="w-[100px] h-[100px] rounded-full bg-green-600 flex items-center justify-center">
            <div className="text-center text-white">
              <div className="text-sm">Math</div>
              <div className="text-lg font-bold">
                Top {getPercentile(averagemath, 'math')} percentile
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Total SAT Score Chart */}
      <div className="h-48">
        <h3 className="text-white text-center mb-2">Total SAT Score</h3>
        <Bar 
          data={totalScoreData} 
          options={{
            ...commonOptions,
            scales: {
              ...commonOptions.scales,
              y: {
                ...commonOptions.scales.y,
                max: 1600
              }
            }
          }}
        />
      </div>

      {/* English Score Chart */}
      <div className="h-48">
        <h3 className="text-white text-center mb-2">English Score</h3>
        <Bar 
          data={englishScoreData} 
          options={{
            ...commonOptions,
            scales: {
              ...commonOptions.scales,
              y: {
                ...commonOptions.scales.y,
                max: 800
              }
            }
          }}
        />
      </div>

      {/* Math Score Chart */}
      <div className="h-48">
        <h3 className="text-white text-center mb-2">Math Score</h3>
        <Bar 
          data={mathScoreData} 
          options={{
            ...commonOptions,
            scales: {
              ...commonOptions.scales,
              y: {
                ...commonOptions.scales.y,
                max: 800
              }
            }
          }}
        />
      </div>
    </div>
  );
};

export default ScoreAnalysis;